import { SendContactMessageApiRequest } from '../../../types/requests/contact/send-contact-message.request';
import { client } from './client';

export const sendContactMessage = (params: SendContactMessageApiRequest) => client.post<void>('/contact', params);
